"use strict";

module.exports = {
    "user2": {
        "add-account": "Add account",
        "edit-accounts": "Edit accounts",
        "enter": "Log in",
        "exit": "Log out",
        "help": "Help",
        "mail": function(params) {
            var plural = require('/place/sandbox-data/tasks/8/6/2857154668/mounted_arcadia/commerce/adv-front/node_modules/webpack-bem-i18n-loader/plural/en.js');
            return plural({
                count: params.count,
                one: 'new message',
                some: 'new messages',
                many: '',
                none: ''
            });
        },
        "mail_compose": "Compose message",
        "passport": "Account management",
        "settings": "Settings",
        "upload_files": "My Disk",
        "ya_plus": "Get Yandex.Plus",
        "ya_plus_on": "Yandex.Plus"
    }
};